import React, { useState } from "react";
import { Avatar, Divider } from "antd";
import linkedInIcon from "images/icon-linkedin.svg";
import IconMail from "images/icon-mail-outline.svg";

import "./style.scss";

const CardUser = ({ user, boxShadow = true }) => {

  return (
    <div className={"card-user"} style={!boxShadow ? {boxShadow:'none', marginBottom:'60px'} : {}}>
      {/* <h2 className={"title"}>{title}</h2> */}
      <Avatar src={user?.img || ''} className="avatar"></Avatar>
      <Divider className={"divider"} />
      <h3 className={"name"}>{`${user?.firstName || ''} ${user?.lastName || ''}`}</h3>
      <p style={{ fontSize: "15px" }}>{user?.titleProfessions || ''}</p>
      <p style={{ fontSize: "15px" }}>{user?.company || ''}</p>
      <p className={"text-content"}>{/* Co-Founder Hacking HR */}</p>

      <div
        className={"container"}
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <a
          href={user?.personalLinks?.linkedin || ''}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className={"icon-linkedin"} src={linkedInIcon} alt="linkedin" />
        </a>
        <a href={`mailto:${user?.email || ''}`}>
          <img
            src={IconMail}
            alt="email"
            style={{
              width: "2.4rem",
            }}
          />
        </a>
      </div>
    </div>
  );
};

export default CardUser;
